export const getEnvironment = (isApi: boolean): string => {
  // Local-dev escape hatch: point API calls at a locally running service (or a
  // local reverse proxy that fans out to several) instead of the QA gateway.
  // Read from .env.local, which is gitignored. Honoured only by the dev server
  // (`import.meta.env.DEV`): it retargets EVERY API call, so a stray
  // .env.local or CI variable must not be able to reach a built bundle.
  const apiOverride: string | undefined = import.meta.env.VITE_API_BASE_URL;
  if (import.meta.env.DEV && isApi && apiOverride) {
    return apiOverride;
  }
  const fullDomain: string = '.app.planomatic.com';
  const subdomain: string = isApi ? 'api' : 'auth';

  if (!targetsProductionBackend()) {
    return `https://qa-${subdomain}${fullDomain}`;
  }

  return `https://${subdomain}${fullDomain}`;
};

/**
 * Does this build talk to the production backend? Only QA and PROD backends
 * exist. A QA-hosted frontend (origin contains 'qa') and local development
 * both target the QA backend; everything else (the prod origin) targets prod.
 *
 * Not `isProduction()`, which is true for every built bundle, QA's included.
 */
export const targetsProductionBackend = (): boolean => {
  const isQa: boolean = window.origin.includes('qa');
  const isLocal: boolean = window.origin.includes('localhost');
  return !(isQa || isLocal || import.meta.env.DEV);
};

export const getAPIUrls = (relativePath: string): string => {
  return `${getEnvironment(true)}${relativePath}`;
};

export const isProduction = (): boolean => {
  return import.meta.env.PROD;
};
